import { Box } from '@src/atoms/Box';
import React, { FC, useState } from 'react';
import { TControllerValue } from '../../models';
import { useSyncFilterValue } from '../../useSyncValue';
import { ISwipeDialogComponentProps } from '../models';
import { FilterSwipeDialogWrapper } from '../_Wrapper/FilterSwipeDialogWrapper';
import { Input } from '@src/atoms/Input/Input';

export const FiltersSwipeDialogString: FC<ISwipeDialogComponentProps> = ({
  controller,
  loading,
  resultText,
  filter,
  setActiveFilterName,
}) => {
  const appliedValues = useSyncFilterValue({ controller, event: filter.name }) as TControllerValue<string>;
  const [inputValue, setInputValue] = useState(appliedValues?.value);

  const handleClose = () => {
    setActiveFilterName(null);
  };

  const handleSubmit = () => {
    controller.onChange(filter.name, inputValue as string);
    handleClose();
  };

  const handleInputChange = (v) => {
    setInputValue(v.target.value);
  };

  return (
    <FilterSwipeDialogWrapper
      title={filter.title}
      loading={loading}
      resultText={resultText}
      onBack={handleClose}
      onSubmit={handleSubmit}
    >
      <Box padding={16} fullWidth gap={8}>
        <Input id="filterStringInput" value={inputValue || undefined} onChange={handleInputChange} />
      </Box>
    </FilterSwipeDialogWrapper>
  );
};
